module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial2@2x_34bbd0.jpg";